import { useState } from 'react';
import { subscribeNewsletter } from '@/hooks/useApi';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    try {
      await subscribeNewsletter(email);
      setSubmitted(true);
      setEmail('');
    } catch {
      setError('حدث خطأ، حاولي مرة أخرى');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: '#e2f0bf' }}>
      <div className="container-main">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold mb-4" style={{ color: '#11120f' }}>انضمي إلى قائمتنا الخاصة</h2>
          <p className="text-sm md:text-base mb-8" style={{ color: '#333' }}>
            احصلي على عروض حصرية، نصائح العناية بالبشرة، ووصول مبكر للمجموعات الجديدة
          </p>

          {submitted ? (
            <div className="bg-white rounded-2xl p-8 border" style={{ borderColor: '#c8d99a' }}>
              <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-2xl text-green-600" />
              </div>
              <h3 className="text-lg font-bold mb-2" style={{ color: '#11120f' }}>تم الاشتراك بنجاح!</h3>
              <p className="text-sm" style={{ color: '#555' }}>سنرسل لكِ أحدث العروض والأخبار</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="أدخل بريدك الإلكتروني"
                required
                className="flex-1 bg-white border rounded-full px-6 py-3.5 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black/20"
                style={{ borderColor: '#c8d99a', color: '#11120f' }}
              />
              <button type="submit" disabled={loading} className="px-6 py-3 rounded-full text-sm font-medium text-white transition-colors disabled:opacity-50" style={{ backgroundColor: '#11120f' }}>
                {loading ? 'جاري...' : 'اشتركي الآن'}
              </button>
            </form>
          )}
          {error && <p className="text-red-500 text-sm mt-3">{error}</p>}

          <p className="text-xs mt-4" style={{ color: '#555' }}>
            بإشتراكك، أنت توافقين على سياسة الخصوصية. يمكنكِ إلغاء الاشتراك في أي وقت.
          </p>
        </div>
      </div>
    </section>
  );
}
